import React, {useEffect, useState} from "react";
import LoadingContent from "../../public/LoadingContent.js";
import TopbarNav from "../Sidebar/TopbarNav.js";
import {Card} from "react-bootstrap";
import clientsService from "../../../services/clientsService.js";
import chartsService from "../../../services/chartsService.js";
import {Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";

const DashboardAdmin = () => {

    const [tasksByStatus, setTasksByStatus] = useState([]);
    const [tasksByUsers, setTasksByUsers] = useState([]);
    const [tasksByCustomData, setTasksByCustomData] = useState([]);
    const [clients, setClients] = useState([]);
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    let called = 0;

    const calledLoading = () => {
        called++;
        if (called === 4){
            setLoading(false);
        }
    }

    const loadClients = () => {
        clientsService.getClients().then(data => {
            if(data.success){
                setClients(data.data);
            }
            calledLoading();
        });
    }

    const loadProjectsByClient = (start_date, end_date) => {
        chartsService.getProjectsCountByClient().then(data => {
            setProjects(data);
            calledLoading();
        });
    }

    const GetTasksCountGroupedByStatus = (start_date, end_date) => {
        chartsService.getTasksCountGroupedByStatus(start_date, end_date).then(data => {
            const tasks = [];
            if (data && data.length > 0) {
                data.forEach(item => {
                    tasks.push({
                        name: item.Status,
                        Tareas: item.Tasks,
                        color: item.Color
                    });
                });
            }
            setTasksByStatus(tasks);
            calledLoading();
        });
    }

    const GetTasksCountGroupedByUsers = (start_date, end_date) => {
        chartsService.getTasksCountGroupedByUsers(start_date, end_date).then(data => {
            const tasks = [];
            if (data && data.length > 0) {
                data.forEach(item => {
                    tasks.push({
                        name: item.User,
                        Tareas: item.Tasks,
                    });
                });
            }
            setTasksByUsers(tasks);
            calledLoading();
        });
    }

    const GetTasksCountByCustomData = (start_date, end_date) => {
        chartsService.getTasksCountByCustomData(start_date, end_date).then(data => {
            setTasksByCustomData(data);
            calledLoading();
        });
    }

    useEffect(() => {

        const today = new Date();
        const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastDayThisMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        const start_date = firstDayLastMonth.toISOString().split("T")[0];
        const end_date = lastDayThisMonth.toISOString().split("T")[0];

        setLoading(true);
        loadClients();
        loadProjectsByClient(start_date, end_date);
        GetTasksCountGroupedByUsers(start_date, end_date);
        GetTasksCountByCustomData(start_date, end_date);
        GetTasksCountGroupedByStatus(start_date, end_date);
    },[])

    return (
        <div className="container-fluid" style={{background: 'url(/waves-white.png)'}}>
            <div className="row">

                <TopbarNav/>

                <div className="col-md-12 col-lg-12 p-4 content-container vh-100">

                    {loading && (
                        <LoadingContent/>
                    )}

                    {!loading && (
                        <div className="row">
                            <div className="col col-3">
                                <Card className="shadow-sm" style={{marginTop: '50px'}}>
                                    <Card.Header className="bg-secondary text-white">
                                        <h5 className="mb-0 text-center">Total de Clientes</h5>
                                    </Card.Header>
                                    <Card.Body>
                                        <h3 className="text-center">{clients.length}</h3>
                                    </Card.Body>
                                </Card>
                            </div>
                            <div className="col col-3">
                                <Card className="shadow-sm" style={{marginTop: '50px'}}>
                                    <Card.Header className="bg-secondary text-white">
                                        <h5 className="mb-0 text-center">Proyectos por Cliente</h5>
                                    </Card.Header>
                                    <Card.Body>
                                        {projects && projects.length > 0 ? (
                                            <>
                                                {projects.map((project, key) => (
                                                    <div key={key} className="row">
                                                        <div className="col col-9">{project.value}</div>
                                                        <div className="col col-3 text-center"><b>{project.count}</b></div>
                                                    </div>
                                                ))}
                                            </>
                                        ) : (
                                            <p>No hay datos disponibles</p>
                                        )}
                                    </Card.Body>
                                </Card>
                            </div>

                            <div className="col col-3">
                                <Card className="shadow-sm" style={{marginTop: '50px'}}>
                                    <Card.Header className="bg-secondary text-white">
                                        <h5 className="mb-0">Tareas por estado</h5>
                                    </Card.Header>
                                    <Card.Body>
                                        {tasksByStatus.length > 0 ? (
                                            <ResponsiveContainer width="100%" height={300}>
                                                <BarChart data={tasksByStatus}>
                                                    <XAxis dataKey="name" />
                                                    <YAxis />
                                                    <Tooltip />
                                                    <Bar dataKey="Tareas">
                                                        {tasksByStatus.map((entry, index) => (
                                                            <Cell key={`cell-${index}`} fill={entry.color} />
                                                        ))}
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer>
                                        ) : (
                                            <p>No hay datos disponibles</p>
                                        )}
                                    </Card.Body>
                                </Card>
                            </div>

                            <div className="col col-3">
                                <Card className="shadow-sm" style={{marginTop: '50px'}}>
                                    <Card.Header className="bg-secondary text-white">
                                        <h5 className="mb-0">Tareas por usuarios asignados</h5>
                                    </Card.Header>
                                    <Card.Body>
                                        {tasksByUsers.length > 0 ? (
                                            <ResponsiveContainer width="100%" height={300}>
                                                <BarChart data={tasksByUsers}>
                                                    <XAxis dataKey="name" />
                                                    <YAxis />
                                                    <Tooltip />
                                                    <Bar dataKey="Tareas">
                                                        {tasksByUsers.map((entry, index) => (
                                                            <Cell key={`cell-${index}`} fill="#4e97D1" />
                                                        ))}
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer>
                                        ) : (
                                            <p>No hay datos disponibles</p>
                                        )}
                                    </Card.Body>
                                </Card>
                            </div>

                            {tasksByCustomData?.length > 0 ? (
                                tasksByCustomData.map((entry, index) => (
                                    <div key={index} className="col col-3">
                                        <Card className="shadow-sm" style={{ marginTop: '50px' }}>
                                            <Card.Header className="bg-secondary text-white">
                                                <h5 className="mb-0">{entry.category}</h5>
                                            </Card.Header>
                                            <Card.Body>
                                                {entry.results.length > 0 ? (
                                                    <ResponsiveContainer width="100%" height={300}>
                                                        <BarChart data={entry.results}>
                                                            <XAxis dataKey="title" />
                                                            <YAxis />
                                                            <Tooltip />
                                                            <Bar dataKey="tasks">
                                                                {entry.results.map((entry, index) => (
                                                                    <Cell key={`cell-${index}`} fill="#008f39" />
                                                                ))}
                                                            </Bar>
                                                        </BarChart>
                                                    </ResponsiveContainer>
                                                ) : (
                                                    <p>No hay datos disponibles</p>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </div>
                                ))
                            ) : (
                                <div></div>
                            )}

                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}

export default DashboardAdmin;